import { Box, Stack, Text, useTheme } from '@ltvco/refresh-lib/theme';
import { AccountResponse } from '@ltvco/refresh-lib/v1';

export const ProfileSection = ({
  account,
  isHovered = false,
}: {
  account: AccountResponse | undefined;
  isHovered?: boolean;
}) => {
  const user = account?.account?.user_info;
  const theme = useTheme();
  return (
    <Box display="flex" sx={{ cursor: 'pointer' }}>
      <Stack gap="4px">
        <Text
          variant="body2"
          sx={{
            color: isHovered
              ? theme.palette.primary.main
              : theme.palette.text.secondary,
            fontWeight: '700',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
        >
          {user?.first_name}
        </Text>
        <Text
          variant="caption"
          sx={{
            fontStyle: 'regular',
            color: theme.palette.text.secondary,
            fontWeight: '400',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
        >
          {account?.account?.subscription_info?.public_plan_type}
        </Text>
      </Stack>
    </Box>
  );
};
